import { Component, OnInit } from '@angular/core';
import { Profile } from 'src/app/models/profile';
import { RoleDto } from 'src/app/models/RoleDto';
import { RolesService } from 'src/app/services/roles.service';
import { UserService } from 'src/app/services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.css']
})
export class UserlistComponent implements OnInit {
profiles:Profile[]=[];
Roles:RoleDto[]=[];
listOfAvailableRoles:RoleDto[]=[];
listOfSelectedValue :RoleDto[]=[];
allowedRoles:RoleDto[]=[];
size:number=0;
loading: boolean = true;
selectedUSer:any;
ViewUserVisible:boolean=false;
  constructor( private notification: NotificationService, private modalService: NgbModal,private roleService: RolesService,     private userService:UserService) { }

  ngOnInit(): void {
    this.loadRecords();
  }
  async  loadRecords()
  {
 
    let  result = await this.userService.getUsers().toPromise(); 
    this.profiles = <Profile[]> result.responseData;
    this.size =this.profiles.length;
    this.loading = false;
  
  }

  async openUser(profile:Profile)
  {
   this.selectedUSer=profile;
   let  result = await this.roleService.getRolesForUser(profile.id).toPromise(); 
   this.Roles = <RoleDto[]> result.responseData;
   this.ViewUserVisible=true;

    
   let  resultRoles = await this.roleService.getRoles().toPromise(); 
    this.listOfAvailableRoles = <RoleDto[]> resultRoles.responseData;



   this.allowedRoles=this.listOfAvailableRoles.filter(role=> !this.Roles.some(present=> present.id==role.id));

              
 
  }

  
  beginDeactivate(profile:Profile)
  {


  }
  cancel()
  {


  }
  downloadExcel(){

  }
  close(){

    this.ViewUserVisible = false;
  }

  openNewRoleModal(content:any)
  {

    this.modalService.open(content, { centered: true });

  }
  addRole()
  {
;
var userid = this.selectedUSer.id;
var selectedRoles = this.listOfSelectedValue;
const selectedIds =this. listOfSelectedValue.map(({ id }) => id);

if(!userid){
  this.notification.sendMessage({
    message: 'No User selected',
    type: NotificationType.success
  });


return;
}
if(selectedIds.length==0)
{
  this.notification.sendMessage({
    message: 'No role selected',
    type: NotificationType.success
  });

  return;
}
let rolerequest: object = {
  userid:userid,
  roleIds:selectedIds
  
};

this.userService.assignRolesToUser(rolerequest).subscribe({
  next: (data => {
    
    if (data.responseCode == "00") {
      this.notification.sendMessage({
        message: data.message,
        type: NotificationType.success
      });

    
      this.modalService.dismissAll();
      window.location.reload();

    }
    else {

      this.notification.sendMessage({
        message: data.message,
        type: NotificationType.error
      });

    }

  }),
  error: ((error: any) => {
    console.log(error.error);
    ;


    this.notification.sendMessage({
      message: error.error.message,
      type: NotificationType.error
    });
  })

});
}




removeRole(data:RoleDto)
  {
;
var userid = this.selectedUSer.id;


if(!userid){
  this.notification.sendMessage({
    message: 'No User selected',
    type: NotificationType.success
  });


return;
}
 
let rolerequest: object = {
  userId:userid,
  id:data.id
  
};

this.userService.removeRoleToUser(rolerequest).subscribe({
  next: (data => {
    
    if (data.responseCode == "00") {
      this.notification.sendMessage({
        message: data.message,
        type: NotificationType.success
      });

    
      this.modalService.dismissAll();
      window.location.reload();

    }
    else {

      this.notification.sendMessage({
        message: data.message,
        type: NotificationType.error
      });

    }

  }),
  error: ((error: any) => {
    console.log(error.error);
    ;


    this.notification.sendMessage({
      message: error.error.message,
      type: NotificationType.error
    });
  })

});
}

}
